import { Ref } from 'react';
import { StyledLinkAnimationText } from '~/shared/styles/Link';
import { StyledLink } from './styled';

type Props = {
    searchUrl: string;
    searchQuery: string;
    suggestion: string;
    ref?: Ref<HTMLAnchorElement>;
};

export const Suggestion = ({ searchUrl, searchQuery, suggestion, ref, ...rest }: Props) => {
    const url = searchUrl ? `${searchUrl}?q=${suggestion}` : '#';

    const searchQueryIndex = suggestion.toLowerCase().indexOf(searchQuery.toLowerCase());
    const searchResult = suggestion.slice(0, searchQueryIndex + searchQuery.length);
    const searchSuggestion = suggestion.slice(searchQueryIndex + searchQuery.length);

    return (
        <li>
            <StyledLink
                href={url}
                ref={ref}
                {...rest}
                multipleElements
                animation="reverse"
            >
                <StyledLinkAnimationText>
                    <span className="searchResult">{searchResult}</span>
                    <span className="searchSuggestion">{searchSuggestion}</span>
                </StyledLinkAnimationText>
            </StyledLink>
        </li>
    );
};
